import { lazyWithPreload } from '../../navigation';

export * from './SiteCard';
export * from './SitesListContent';

export const SitesListScreen = lazyWithPreload(() =>
    import('./SitesListScreen').then((m) => ({ default: m.SitesListScreen }))
);
